export default {
  path: '/material_product_lots',
  name: 'material_product_lots',
  component: () => import('../components/materialproductlot/Layout'),
  redirect: { name: 'MaterialProductLotList' },
  meta: {
    breadcrumb: 'profile.material.productlots',
  },
  children: [
    {
      name: 'MaterialProductLotList',
      path: '',
      component: () => import('../views/materialproductlot/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'MaterialProductLotCreate',
      path: 'new',
      component: () => import('../views/materialproductlot/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'MaterialProductLotUpdate',
      path: ':id/edit',
      component: () => import('../views/materialproductlot/Update'),
      meta: {
        breadcrumb: 'profile.material.productlot',
      },
    },
    {
      name: 'MaterialProductLotShow',
      path: ':id',
      component: () => import('../views/materialproductlot/Show'),
      meta: {
        breadcrumb: 'profile.material.productlot',
      },
    }
  ]
};
